import apiV2 from "api-v2";
import { Rfx } from "newui/features/Rfx/types/rfx.types";
import {
	endPerformance,
	logPerformance,
	startPerformance,
} from "utils/logging";

export const getRfxById = async (
	id: number,
	includes: string[] | null
): Promise<Rfx | null> => {
	const startTime = startPerformance();
	try {
		const request = `rfq/${id}${includes ? `?include=${includes.join(",")}` : ""}`;
		const { data: rfq } = await apiV2.get(request);
		if (rfq.status) {
			return rfq.data as Rfx;
		} else {
			return null;
		}
	} catch (err) {
		return null;
	} finally {
		const endTime = endPerformance();
		logPerformance(startTime, endTime, "getRfxById");
	}
};
